<template>
  <div class="page flex-col">
    <div class="content-container">
      <div class="section_1 flex-row justify-end" :class="{ 'sticky-header': isSticky }">
        <img
          class="image_1"
          referrerpolicy="no-referrer"
          src="./assets/img/logo.jpg"
        />
        <a href="#product-ability" class="text_1" @click.prevent="scrollToElement('product-ability')">产品能力</a>
        <a href="#application-scenarios" class="text_2" @click.prevent="scrollToElement('application-scenarios')">应用场景</a>
        <a href="https://xmkf.yuanzhiqi.com" class="text_project_coop" target="_blank" rel="noopener">AI项目开发合作</a>
        <a href="https://zyfdw.yuanzhiqi.com" class="text_ai_case" target="_blank" rel="noopener">AI应用案例</a>
        <a href="#about-us" class="text_3" @click.prevent="scrollToElement('about-us')">关于我们</a>
        <a href="#agent-cooperation" class="text_4" @click.prevent="scrollToElement('agent-cooperation')">代理合作</a>
        <a href="#" class="text_5" @click.prevent="showMaintenanceMessage">帮助中心</a>
        <div class="text-wrapper_free-trial flex-col" @click="openLoginPage">
          <span class="text_free-trial">免费试用</span>
        </div>
        <div class="text-wrapper_1 flex-col" @click="openLoginPage">
          <span class="text_6">立即登录</span>
        </div>
      </div>
      <div class="section_2 flex-col">
        <!-- 主视觉横幅 -->
        <div class="group_1 flex-col">
          <img
            class="image_2"
            referrerpolicy="no-referrer"
            src="./assets/img/SketchPng173d756a67facd78f591a41aa39bdf8e8f1988e06dd9bf86b8120c7886ea8328.png"
          />
          <div class="text-wrapper_2">
            <span class="text_7">企业级</span>
            <span class="text_8">AI应用配置平台</span>
          </div>
          <span class="text_9">低成本、无门槛、AI应用轻松配</span>
          <div class="box_1 flex-row">
            <div class="image-text_1 flex-row justify-between" @click="openLoginPage" style="cursor: pointer;">
              <img
                class="thumbnail_1"
                referrerpolicy="no-referrer"
                src="./assets/img/SketchPng98a314bf56bfbaba64a312684441b9ada5121f97b8229a839e5595d5380bcef8.png"
              />
              <span class="text-group_1">免费试用</span>
            </div>
          </div>
        </div>

        <!-- 平台优势部分 -->
        <div class="group_2 flex-row">
          <div class="text-wrapper_3 flex-col justify-between">
            <span class="text_10">低成本</span>
            <span class="paragraph_1">
              开发快
              <br />
              投入少，要求低
            </span>
          </div>
          <img
            class="image_3"
            referrerpolicy="no-referrer"
            src="./assets/img/SketchPngc6a3086b19b03ce1f5a2022e2b84dcb38a6e3785aa3787e568aaedfd09f02520.png"
          />
          <div class="text-wrapper_4 flex-col justify-between">
            <span class="text_11">无门槛</span>
            <span class="paragraph_2">
              零基础
              <br />
              秒上手，轻松搭
            </span>
          </div>
          <img
            class="image_4"
            referrerpolicy="no-referrer"
            src="./assets/img/SketchPngc6a3086b19b03ce1f5a2022e2b84dcb38a6e3785aa3787e568aaedfd09f02520.png"
          />
          <div class="text-wrapper_5 flex-col justify-between">
            <span class="text_12">零代码</span>
            <span class="paragraph_3">
              告别代码
              <br />
              可视化配置
            </span>
          </div>
          <img
            class="image_5"
            referrerpolicy="no-referrer"
            src="./assets/img/SketchPngc6a3086b19b03ce1f5a2022e2b84dcb38a6e3785aa3787e568aaedfd09f02520.png"
          />
          <div class="text-wrapper_6 flex-col justify-between">
            <span class="text_13">配置快</span>
            <span class="paragraph_4">
              1小时搭好
              <br />
              快人一步
            </span>
          </div>
          <img
            class="image_6"
            referrerpolicy="no-referrer"
            src="./assets/img/SketchPngc6a3086b19b03ce1f5a2022e2b84dcb38a6e3785aa3787e568aaedfd09f02520.png"
          />
          <div class="text-wrapper_7 flex-col justify-between">
            <span class="text_14">应用广</span>
            <span class="paragraph_5">
              百业适配
              <br />
              AI覆盖全场景
            </span>
          </div>
        </div>

        <!-- 其他所有内容保持不变 -->
        <div class="group_3 flex-col" id="product-ability">
          <div class="group_4 flex-row">
            <div class="text-group_2 flex-col justify-between">
              <span class="text_15">产品能力</span>
              <span class="text_16"
                >企业&nbsp;AI&nbsp;应用创新平台，低代码轻松构建智能体</span
              >
            </div>
          </div>
          <div class="group_5 flex-row justify-between">
            <div class="group_6 flex-col justify-between">
              <div class="section_3 flex-row" @click="switchProductAbility(1)" style="cursor: pointer;" :class="{'active-item': selectedProductAbility === 1}">
                <div class="box_2 flex-col" :style="{visibility: selectedProductAbility === 1 ? 'visible' : 'hidden'}"></div>
                <div class="image-text_2 flex-row justify-between">
                  <img
                    class="label_1"
                    referrerpolicy="no-referrer"
                    :src="require('./assets/img/ai.png')"
                  />
                  <span class="text-group_3">大模型</span>
                </div>
              </div>
              <div class="section_4 flex-row" @click="switchProductAbility(2)" style="cursor: pointer;" :class="{'active-item': selectedProductAbility === 2}">
                <div class="box_2 flex-col" :style="{visibility: selectedProductAbility === 2 ? 'visible' : 'hidden'}"></div>
                <div class="image-text_3 flex-row justify-between">
                  <img
                    class="label_2"
                    referrerpolicy="no-referrer"
                    src="./assets/img/SketchPng028cabe928905ec677678f28f8852107a97626bfc5256f99b6f23d1556e4e2f2.png"
                  />
                  <span class="text-group_4">知识库</span>
                </div>
              </div>
              <div class="section_5 flex-row" @click="switchProductAbility(3)" style="cursor: pointer;" :class="{'active-item': selectedProductAbility === 3}">
                <div class="box_2 flex-col" :style="{visibility: selectedProductAbility === 3 ? 'visible' : 'hidden'}"></div>
                <div class="image-text_4 flex-row justify-between">
                  <img
                    class="label_3"
                    referrerpolicy="no-referrer"
                    src="./assets/img/SketchPng803ff1e203f09ca036a77389562f0213dfa8be097d8a92db4e75d9fc604a8f0b.png"
                  />
                  <span class="text-group_5">数据库</span>
                </div>
              </div>
              <div class="section_6 flex-row" @click="switchProductAbility(4)" style="cursor: pointer;" :class="{'active-item': selectedProductAbility === 4}">
                <div class="box_2 flex-col" :style="{visibility: selectedProductAbility === 4 ? 'visible' : 'hidden'}"></div>
                <div class="image-text_5 flex-row justify-between">
                  <img
                    class="label_4"
                    referrerpolicy="no-referrer"
                    src="./assets/img/SketchPng14734cb58d2862a7482bf1c680a76051a0aa7eebb23dd7f2a975776e9c48b2b2.png"
                  />
                  <span class="text-group_6">插件</span>
                </div>
              </div>
              <div class="section_7 flex-row" @click="switchProductAbility(5)" style="cursor: pointer;" :class="{'active-item': selectedProductAbility === 5}">
                <div class="box_2 flex-col" :style="{visibility: selectedProductAbility === 5 ? 'visible' : 'hidden'}"></div>
                <div class="image-text_6 flex-row justify-between">
                  <img
                    class="label_5"
                    referrerpolicy="no-referrer"
                    src="./assets/img/SketchPng0022e10f7a254bc8e0c72599e3f08d9e294c8e7be19ade71e8717f574b29c4e6.png"
                  />
                  <span class="text-group_7">工作流</span>
                </div>
              </div>
              <div class="section_8 flex-row" @click="switchProductAbility(6)" style="cursor: pointer;" :class="{'active-item': selectedProductAbility === 6}">
                <div class="box_2 flex-col" :style="{visibility: selectedProductAbility === 6 ? 'visible' : 'hidden'}"></div>
                <div class="image-text_7 flex-row justify-between">
                  <img
                    class="label_6"
                    referrerpolicy="no-referrer"
                    src="./assets/img/SketchPng984add0fddca3424201386e11bd07ff64145f81041e48da2fc1db96c83aa3109.png"
                  />
                  <span class="text-group_8">渠道接入</span>
                </div>
              </div>
            </div>
            <div class="group_7 flex-row">
              <div class="section_9 flex-col">
                <span class="text_17">{{ selectedProductAbility === 1 ? '大模型' :
                                      selectedProductAbility === 2 ? '知识库' :
                                      selectedProductAbility === 3 ? '数据库' :
                                      selectedProductAbility === 4 ? '插件' :
                                      selectedProductAbility === 5 ? '工作流' : '渠道接入' }}</span>
                <div class="text-wrapper_8">
                  <!-- 大模型内容 -->
                  <template v-if="selectedProductAbility === 1">
                    <span class="paragraph_6">
                      构建了强大的多模型融合体系，
                      <br />
                      整合了
                    </span>
                    <span class="text_18">业界领先</span>
                    <span class="paragraph_7">
                      的通用大模型及行业大模型。
                      <br />
                    </span>
                  </template>
                  <!-- 知识库内容 -->
                  <template v-else-if="selectedProductAbility === 2">
                    <span class="paragraph_6">
                      支持文档、问答、表格、网站等多元数据格式的无缝接入
                      <br />
                      实现全类型知识资产的一站式管理
                    </span>
                  </template>
                  <!-- 数据库内容 -->
                  <template v-else-if="selectedProductAbility === 3">
                    <span class="paragraph_6">
                      支持多种数据库类型的连接与集成
                      <br />
                      实现数据的智能查询与分析
                    </span>
                  </template>
                  <!-- 插件内容 -->
                  <template v-else-if="selectedProductAbility === 4">
                    <span class="paragraph_6">
                      插件是对大模型能力的强力扩展
                      <br />
                      通过开放API接口实现与外部系统的智能交互
                    </span>
                  </template>
                  <!-- 工作流内容 -->
                  <template v-else-if="selectedProductAbility === 5">
                    <span class="paragraph_6">
                      工作流具备强大的交叉编排能力
                      <br />
                      可实现多应用联动、多知识库协同、多数据库交互
                    </span>
                  </template>
                  <!-- 渠道接入内容 -->
                  <template v-else>
                    <span class="paragraph_6">
                      一键接入主流IM和办公协同平台
                      <br />
                      支持微信、企业微信、链接等多种渠道形式
                    </span>
                  </template>
                </div>
                <!-- 大模型特有内容 -->
                <template v-if="selectedProductAbility === 1">
                  <span class="text_19">模型如下：</span>
                  <div class="group_8 flex-row justify-between">
                    <div class="text-wrapper_9 flex-col">
                      <span class="text_20">DeepSeek</span>
                    </div>
                    <div class="text-wrapper_10 flex-col">
                      <span class="text_21">Kimi</span>
                    </div>
                    <div class="text-wrapper_11 flex-col">
                      <span class="text_22">Qwen</span>
                    </div>
                  </div>
                  <div class="group_9 flex-row justify-between">
                    <div class="text-wrapper_12 flex-col">
                      <span class="text_23">Doubao</span>
                    </div>
                    <div class="text-wrapper_13 flex-col">
                      <span class="text_24">智谱</span>
                    </div>
                    <div class="text-wrapper_14 flex-col">
                      <span class="text_25">文心一言</span>
                    </div>
                  </div>
                  <div class="group_10 flex-row justify-between">
                    <div class="section_10 flex-col">
                      <div class="text-wrapper_15">
                        <span class="text_26">专业领域大模型</span>
                        <span class="text_27">(千问法律)</span>
                      </div>
                    </div>
                    <div class="text-wrapper_16 flex-col">
                      <span class="text_28">讯飞星火</span>
                    </div>
                  </div>
                </template>
              </div>
              <div :class="'section_11_' + selectedProductAbility + ' flex-col'">
                <div :class="'group_11_' + selectedProductAbility + ' flex-col'"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="text-group_9 flex-col justify-between" id="application-scenarios">
          <span class="text_29">丰富的应用场景和解决方案</span>
          <span class="text_30">满足多种业务需求</span>
        </div>
        <div class="text-wrapper_17 flex-row justify-between">
          <span class="text_31" @click="switchScenario(1)" :class="{'active-scenario': selectedScenario === 1}" style="cursor: pointer;">智能客服</span>
          <span class="text_32" @click="switchScenario(2)" :class="{'active-scenario': selectedScenario === 2}" style="cursor: pointer;">私域营销</span>
          <span class="text_33" @click="switchScenario(3)" :class="{'active-scenario': selectedScenario === 3}" style="cursor: pointer;">数据助手</span>
          <span class="text_34" @click="switchScenario(4)" :class="{'active-scenario': selectedScenario === 4}" style="cursor: pointer;">智能培训</span>
          <span class="text_35" @click="switchScenario(5)" :class="{'active-scenario': selectedScenario === 5}" style="cursor: pointer;">辅助诊疗</span>
          <span class="text_36" @click="switchScenario(6)" :class="{'active-scenario': selectedScenario === 6}" style="cursor: pointer;">社群营销</span>
        </div>

        <div class="group_13 flex-row justify-between">
          <div class="block_1 flex-col">
            <div class="block_2 flex-row justify-between">
              <div class="text-wrapper_18 flex-col justify-between">
                <span class="text_37">{{ scenarioTitles[selectedScenario-1] }}</span>
                <span class="paragraph_8">
                  {{ scenarioDescriptions[selectedScenario-1].split('\n')[0] }}
                  <br />
                  {{ scenarioDescriptions[selectedScenario-1].split('\n')[1] }}
                </span>
              </div>
              <img
                class="image_7"
                referrerpolicy="no-referrer"
                :src="scenarioIcons[selectedScenario-1]"
              />
            </div>
            <img
              class="image_8"
              referrerpolicy="no-referrer"
              :src="scenarioDetailIcons[selectedScenario-1]"
            />
            <span class="paragraph_9" v-html="scenarioContents[selectedScenario-1]">
            </span>
          </div>
          <div class="block_3 flex-col">
            <div :class="'group_14_' + selectedScenario + ' flex-col'">

            </div>
          </div>
        </div>
        <div class="group_15 flex-col" id="about-us">
          <div class="text-group_10 flex-col justify-between">
            <span class="text_41">关于我们</span>
            <span class="text_42">元智启ai</span>
          </div>
          <div class="section_14 flex-col">
            <img
              class="image_9"
              referrerpolicy="no-referrer"
              src="./assets/img/SketchPng871191049369103473f8ab12ad255b614220dc5931e5d621f78e1f13153eae78.png"
            />
            <span class="paragraph_10">
              元智启ai是四川慧医云科技打造的AI应用零代码配置平台，
              <br />
              致力于为企业提供高效智能化的数字化转型解决方案。
              <br />
              平台通过零代码配置技术，帮助企业快速构建专业级智能应用，
              <br />
              具备部署灵活、成本可控、场景适配性强三大核心优势，
              <br />
              可显著降低AI技术应用门槛。
              <br />
            </span>
            <div class="block_4 flex-col">
              <div class="text-wrapper_22">
                <span class="text_43">平台深度适配各类企业应用场景：</span>
                <span class="paragraph_11">
                  &nbsp;成功应用于"智能客服、智能法律咨询、智能随访、智能问/导诊、对话智能生成病例、智能辅诊、智能库存补货、智能资质审核、智能培训、智能财务单据校验、微信智能营销、智能推荐"等诸多应用场景。
                  <br />
                </span>
              </div>
              <img
                class="image_10"
                referrerpolicy="no-referrer"
                src="./assets/img/SketchPng4345e9f271eabbd7bc13c4627f38785e88b2de434436ddf4d723b57ff4f4ca84.png"
              />
              <span class="paragraph_12">
                元智启ai目前已接入了deepseek、通义千问、豆包、文心一言、智普等诸多通用大模型及行业大模型。
                <br />
                具备聚合多模态、知识库、接口、数据库、插件和工作流等Agent构建能力，可以将各个模块灵活应用调度，零代码搭建私有知识以及复杂任务执行能力的&nbsp;Agent&nbsp;智能体，并一键接入主流&nbsp;IM&nbsp;和办公协同平台等渠道。
              </span>
            </div>
          </div>
        </div>
        <div class="group_16 flex-col" id="agent-cooperation">
          <span class="text_44">企业级一站式AI智能体开发及应用平台</span>
          <div class="list_1 flex-row">
            <div
              class="list-items_1 flex-row"
              v-for="(item, index) in loopData0"
              :key="index"
            >
              <input
                type="text"
                class="thumbnail_2"
                :placeholder="`请输入${item.lanhutext0}`"
                v-model="formData[item.lanhutext0]"
              />
            </div>
          </div>
          <div class="text-wrapper_23 flex-col" @click="openAgencyPage">
            <span class="text_46">商务合作</span>
          </div>
          <div v-if="submitted" class="submission-message">
            很高兴能与您取得联系，我们将在第一时间与您取得联系
          </div>
        </div>
        <div class="group_17 flex-col"></div>
        <div class="group_18 flex-row">
          <img
            class="image_11"
            referrerpolicy="no-referrer"
            src="./assets/img/SketchPng413d8ede82b2639d2f43ab6fdd2038ec19df5281aa701d8ccf99f58f671bd94f.png"
          />
          <span class="text_47">product</span>
          <span class="text_48">RESOURCE</span>
          <span class="text_49">ASK</span>
          <span class="text_50">联系我们</span>
        </div>
        <div class="text-wrapper_24 flex-row">
          <a class="text_51" href="https://ai.yuanzhiqi.com/create/app" target="_blank">快速开始</a>
          <a class="text_52" href="https://doc.yuanzhiqi.com/" target="_blank">帮助中心</a>
          <a class="text_53" href="https://ai.yuanzhiqi.com/manage/account?showUpgrade=true&tab=upgrade" target="_blank">产品版本</a>
          <span class="text_54">联系电话：18848457100（微信同号）</span>
        </div>
        <div class="text-wrapper_25 flex-row">
          <a class="text_55" href="https://ai.yuanzhiqi.com/access/channel" target="_blank">渠道接入</a>
          <a class="text_56" href="https://doc.yuanzhiqi.com/services/#%E6%9B%B4%E6%96%B0%E6%97%A5%E5%BF%97" target="_blank">更新日志</a>
          <a class="text_57" href="https://doc.yuanzhiqi.com/billing/" target="_blank">模型计费</a>
          <span class="text_58">yuanzhiqi_ai@163.com</span>
        </div>
        <div class="group_19 flex-row">
          <a class="text_59" href="https://doc.yuanzhiqi.com/features/create-channel.html#%E5%8D%81%E4%B8%80%E3%80%81%E5%BC%80%E6%94%BEapi" target="_blank">开放API</a>
          <a class="text_61" href="https://doc.yuanzhiqi.com/services/#v1-1-0" target="_blank">常见问题</a>
          <div class="image-text_8 flex-col justify-between">
            <div class="box_3 flex-col"><div class="box_4 flex-col"></div></div>
            <span class="text-group_11">企业微信号</span>
          </div>
        </div>
        <img
          class="image_12"
          referrerpolicy="no-referrer"
          src="./assets/img/SketchPngda9558a16d4ecb0e84b93a433e74d5ab3b9e524292063751bf12e3d60e6dc699.png"
        />
        <div class="beian-container">
          <a class="beian-link" href="https://beian.miit.gov.cn/" target="_blank">蜀ICP备2025131893号-1</a>
          <a class="beian-link" href="https://www.beian.gov.cn/" rel="noreferrer" target="_blank">
            <img class="beian-icon" src="./assets/img/guohui.png" alt="公安备案" />
            川公网安备51010702043860号
          </a>
        </div>
      </div>
    </div>
    <!-- 维护消息 -->
    <div v-if="maintenanceMsg" class="maintenance-message">
      很抱歉，功能正在维护中，请耐心等待....
    </div>
  </div>
</template>

<script>
import config from '@/config.js'

export default {
  data() {
    return {
      loopData0: [
        { lanhutext0: '所属区域', slot1: 1 },
        { lanhutext0: '公司名称' },
        { lanhutext0: '联系人名称' },
        { lanhutext0: '联系方式' }
      ],
      formData: {
        '所属区域': '',
        '公司名称': '',
        '联系人名称': '',
        '联系方式': ''
      },
      submitted: false,
      isSubmitting: false,
      maintenanceMsg: false,
      constants: {},
      // 当前选中的产品能力子项，默认为大模型(1)
      selectedProductAbility: 1,
      // 当前选中的应用场景，默认为智能客服(1)
      selectedScenario: 1,
      // 应用场景标题
      scenarioTitles: ['智能客服', '私域营销', '数据助手', '智能培训', '辅助诊疗', '社群营销'],
      // 应用场景描述(简介)
      scenarioDescriptions: [
        '基于日常客户问答咨询的积累\n将高频问题整理归档至知识库系统',
        '精准触达潜在客户\n提供个性化营销方案和推荐',
        '智能分析企业数据\n提供决策支持和业务洞察',
        '员工培训智能化\n提高培训效率和效果',
        '辅助医疗诊断和治疗\n提供专业医疗知识支持',
        '管理和运营社群\n提高用户活跃度和转化率'
      ],
      // 应用场景详细内容
      scenarioContents: [
        `通过与企业系统对接，将智能体集成至企业商城平台后，<br/>
        实现实时获取咨询客户的身份信息、<br/>
        订单状态及物流详情等业务数据；<br/>
        分析客户咨询内容并自动匹配知识库进行回复；<br/>
        当问题需人工介入时，<br/>
        智能体将自动在企业工单系统中生成待办任务，<br/>
        实现服务流程闭环。`,

        `通过分析用户行为数据和历史互动信息，<br/>
        智能体能够识别潜在的高价值客户，<br/>
        向其精准推送个性化的营销内容和产品推荐；<br/>
        自动分析营销效果，优化营销策略；<br/>
        通过多场景互动，提高客户粘性和复购率，<br/>
        帮助企业构建完整的私域流量运营体系。`,

        `整合企业内部和外部数据源，<br/>
        智能体可快速进行数据清洗、分析和可视化；<br/>
        提供销售预测、库存优化、风险评估等决策支持；<br/>
        通过简单对话即可获取复杂数据分析结果，<br/>
        无需专业数据分析技能；<br/>
        支持定制化报表生成和数据洞察推送。`,

        `为企业打造智能培训系统，<br/>
        根据员工角色和能力水平提供个性化学习路径；<br/>
        通过问答交互方式进行知识点巩固和测试；<br/>
        实时跟踪学习进度和效果，<br/>
        自动生成培训评估报告；<br/>
        降低企业培训成本，提高培训效率和知识保留率。`,

        `辅助医护人员进行初步诊断，<br/>
        根据症状描述提供可能的疾病判断和处理建议；<br/>
        整合最新医学研究成果和临床指南，<br/>
        为医疗决策提供循证医学支持；<br/>
        协助患者理解医疗术语和治疗方案，<br/>
        提高医患沟通效率和满意度。`,

        `智能管理社群内容和互动，<br/>
        自动回应成员常见问题；<br/>
        识别高价值讨论和潜在商机，<br/>
        促进社群成员之间的有效互动；<br/>
        分析社群活跃度和情绪倾向，<br/>
        为运营策略调整提供数据支持；<br/>
        通过精准内容推送，提高用户参与度和转化率。`
      ],
      // 应用场景特点/功能标签
      scenarioFeatures: [
        ['多渠道接入', '智能转人工', '辅助生成回复'],
        ['用户画像分析', '智能推荐', '效果追踪'],
        ['多维数据分析', '智能报表', '预测模型'],
        ['个性化学习', '智能测评', '内容推荐'],
        ['诊断辅助', '医学知识库', '患者教育'],
        ['内容管理', '互动增强', '用户转化']
      ],
      // 滚动相关状态
      isSticky: false,
      // 应用场景图标（小图标）
      scenarioIcons: [
        require('./assets/img/SketchPnga85bd4d2461d56b2c848fe598c30ecb70e2975abb0d5a26e67902928c756db31.png'),
        require('./assets/img/SketchPnga0bf32d5590bee74ee0ef96b91428310d2f35b61db09b8266c2298a6f08ff59c.png'),
        require('./assets/img/SketchPng94ac18f79fb3f8e7cba704fbb52043c05df74695e2a85614ea3cbcc069539657.png'),
        require('./assets/img/SketchPng05dd9f342f3f60d662ade1f7c426538c7eec2b07f5e1dcf9c13f4facd6121b7d.png'),
        require('./assets/img/SketchPng4e27d3cf4cf73e9212295d16d88a5c48430367d1517f23050c2a0b711621d41b.png'),
        require('./assets/img/SketchPng9deba24031865af229edbda0e26373d078dc6639b185f16fca0874227a4f6d88.png')
      ],

      // 应用场景详情图标（大图标）
      scenarioDetailIcons: [
        require('./assets/img/SketchPngf60fad07063dc82eefc88dffdcb5980639b551bd0b5e977bcd786a8c89c5d156.png'),
        require('./assets/img/SketchPngf60fad07063dc82eefc88dffdcb5980639b551bd0b5e977bcd786a8c89c5d156.png'),
        require('./assets/img/SketchPngf60fad07063dc82eefc88dffdcb5980639b551bd0b5e977bcd786a8c89c5d156.png'),
        require('./assets/img/SketchPngf60fad07063dc82eefc88dffdcb5980639b551bd0b5e977bcd786a8c89c5d156.png'),
        require('./assets/img/SketchPngf60fad07063dc82eefc88dffdcb5980639b551bd0b5e977bcd786a8c89c5d156.png'),
        require('./assets/img/SketchPngf60fad07063dc82eefc88dffdcb5980639b551bd0b5e977bcd786a8c89c5d156.png')
      ],

      // 产品能力子项对应的图片
      // 不需要产品能力子项对应的图片了
      productImages: {},

      // 添加环境配置
      config: config
    };
  },
  methods: {
    // 切换产品能力子项
    switchProductAbility(type) {
      this.selectedProductAbility = type;
    },
    // 切换应用场景
    switchScenario(type) {
      this.selectedScenario = type;
    },
    // 提交表单
    submitForm() {
      // 验证表单数据
      const isValid = Object.values(this.formData).every(value => value.trim() !== '');

      if (!isValid) {
        alert('请填写所有表单项');
        return;
      }

      // 设置提交中状态
      this.isSubmitting = true;

      // 根据环境获取API地址
      const baseUrl = this.config.apiUrl;
      const apiUrl = `${baseUrl}api/submit-form`;

      fetch(apiUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(this.formData)
      })
      .then(response => {
        if (!response.ok) {
          throw new Error('提交失败，服务器返回: ' + response.status);
        }
        return response.json();
      })
      .then(data => {
        console.log('表单提交成功:', data);

        // 清空所有输入框
        this.formData = {
          '所属区域': '',
          '公司名称': '',
          '联系人名称': '',
          '联系方式': ''
        };

        // 显示提交成功消息
        this.submitted = true;
        // 3秒后隐藏消息
        setTimeout(() => {
          this.submitted = false;
        }, 3000);
      })
      .catch(error => {
        console.error('表单提交失败:', error);
        alert('提交失败，请稍后重试');
      })
      .finally(() => {
        // 重置提交状态
        this.isSubmitting = false;
      });
    },
    // 处理滚动事件
    handleScroll() {
      const scrollY = window.scrollY;

      this.isSticky = scrollY > 0;
    },
    // 滚动到指定元素
    scrollToElement(elementId) {
      const element = document.getElementById(elementId);
      if (element) {
        // 计算需要滚动的位置（考虑固定导航栏的高度）
        const headerHeight = document.querySelector('.section_1').offsetHeight || 0;
        const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
        const offsetPosition = elementPosition - headerHeight;

        // 平滑滚动到目标位置
        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
      }
    },
    // 在新标签页中打开登录页面
    openLoginPage() {
      window.open("https://ai.yuanzhiqi.com", '_blank');
    },
    // 在新标签页中打开代理合作页面
    openAgencyPage() {
      window.open("http://www.huiyiyunai.com/agency", '_blank');
    },
    // 显示维护中消息
    showMaintenanceMessage() {
      // this.maintenanceMsg = true;
      // setTimeout(() => {
      //   this.maintenanceMsg = false;
      // }, 3000);
      window.open("https://doc.yuanzhiqi.com", '_blank');
    }
  },
  mounted() {
    // 添加滚动事件监听
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeUnmount() {
    // 移除滚动事件监听
    window.removeEventListener('scroll', this.handleScroll);
  }
};
</script>

<style scoped lang="css" src="./assets/index.rem.css" />
<style scoped>
/* 覆盖router-link的默认样式，保持与原始span相同的样式 */
a {
  text-decoration: none;
  display: inline-block;
  color: inherit;
  cursor: pointer;
}

.text-wrapper_24 a:hover,
.text-wrapper_25 a:hover,
.group_19 a:hover {
  color: #2187fa;
}

.text_project_coop,
.text_ai_case {
  height: 0.427rem;
  overflow-wrap: break-word;
  color: rgba(0, 0, 0, 1);
  font-size: 0.426rem;
  text-align: left;
  white-space: nowrap;
  line-height: 0.427rem;
  margin: 0.774rem 0 0 2.134rem;
}

.section_1 {
  justify-content: flex-start;
}

.text_1 {
  margin-left: 7.2rem;
}

.text_2,
.text_project_coop,
.text_ai_case,
.text_3,
.text_4,
.text_5 {
  margin-left: 1.28rem;
}

.text-wrapper_free-trial {
  margin-left: auto;
}

/* 左侧条样式 - 默认隐藏 */
.box_2 {
  width: 0.053rem;
  height: 100%;
  /* margin: 0.267rem 0.213rem 0 0; */
  visibility: hidden;
}

/* 选中项的左侧条，显示蓝色 */
.active-item .box_2 {
  background-color: rgba(33, 135, 250, 1);
  visibility: visible;
}

/* 选中项的背景样式 */
.section_3, .section_4, .section_5, .section_6, .section_7, .section_8 {
  border-radius: 0.107rem;
}

/* 选中项的背景颜色 */
.active-item {
  background-color: rgba(240, 245, 255, 1);
}

/* 选中项的文字颜色 */
.active-item span {
  color: #2187fa !important;
}

/* 未选中项的文字颜色 - 确保一致性 */
.text-group_3, .text-group_4, .text-group_5, .text-group_6, .text-group_7, .text-group_8 {
  color: rgba(0, 0, 0, 0.85);
}

/* 选中项的图标滤镜 - 将图标转为蓝色 */
.active-item img {
  filter: hue-rotate(180deg) brightness(0.8) saturate(8);
}

/* 产品能力子项对应的样式 */
.section_11_1, .section_11_2, .section_11_3, .section_11_4, .section_11_5, .section_11_6 {
  height: 10.668rem;
}

/* group_11 对应的样式 */
.group_11_1, .group_11_2, .group_11_3, .group_11_4, .group_11_5, .group_11_6 {
  height: 8.001rem;
  width: 100%;
}

/* 表单元素样式 */
.thumbnail_2 {
  height: 100%;
  width: 100%;
  border: 0.027rem solid #e8e8e8;
  border-radius: 0.107rem;
  padding: 0 0.4rem;
  background-color: #fff;
  color: rgba(0, 0, 0, 0.85);
  font-size: 0.373rem;
  box-sizing: border-box;
  outline: none;
}

.thumbnail_2:focus {
  border-color: #2187fa;
  outline: none;
  box-shadow: 0 0 0 0.053rem rgba(33, 135, 250, 0.1);
}

.thumbnail_2::placeholder {
  color: rgba(0, 0, 0, 0.25);
}

.list_1 {
  /* flex-wrap: wrap; */
  justify-content: flex-start;
  gap: 0.533rem;
  margin-bottom: 0.533rem;
}

.list-items_1 {
  display: flex;
  align-items: center;
  margin-bottom: 0.267rem;
}

.text_45 {
  width: 2.134rem;
  text-align: left;
  margin-right: 0.267rem;
}

.text-wrapper_23 {
  cursor: pointer;
  transition: all 0.3s;
}

.text-wrapper_23:hover {
  opacity: 0.8;
}

.text-wrapper_23.disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.submission-message {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: rgba(0, 0, 0, 0.7);
  color: #fff;
  font-size: 0.427rem;
  padding: 0.4rem 0.8rem;
  border-radius: 0.107rem;
  box-shadow: 0 0.107rem 0.32rem rgba(0, 0, 0, 0.15);
  z-index: 9999;
  text-align: center;
  animation: fadeIn 0.3s ease-in-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translate(-50%, -40%);
  }
  to {
    opacity: 1;
    transform: translate(-50%, -50%);
  }
}

/* 吸顶导航样式 */
.sticky-header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background-color: #fff;
  box-shadow: 0 0.053rem 0.267rem rgba(0, 0, 0, 0.1);
  transition: transform 0.5s ease, opacity 0.5s ease;
}

.text-wrapper_1 {
  cursor: pointer;
  transition: all 0.2s;
}

.text-wrapper_1:hover {
  opacity: 0.8;
}

.maintenance-message {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: rgba(0, 0, 0, 0.7);
  color: #fff;
  font-size: 0.427rem;
  padding: 0.4rem 0.8rem;
  border-radius: 0.107rem;
  box-shadow: 0 0.107rem 0.32rem rgba(0, 0, 0, 0.15);
  z-index: 9999;
  text-align: center;
  animation: fadeIn 0.3s ease-in-out;
}

/* 应用场景选中样式 */
.active-scenario {
  padding: 0 0 1.334rem 0;
  color: #2187fa;
  font-weight: 500;
  position: relative;
}

.active-scenario::after {
  content: '';
  position: absolute;
  bottom: -0.133rem;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  height: 0.08rem;
  background-color: #2187fa;
  border-radius: 0.053rem;
}

</style>
